import { render, staticRenderFns } from "./ClientsToolbar.vue?vue&type=template&id=8ecec9dc&"
import script from "./ClientsToolbar.vue?vue&type=script&lang=js&"
export * from "./ClientsToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports